import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';

if (environment.production) {
    enableProdMode();
}
polyfillCountryFlagEmojis();

platformBrowser()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
